import { OrderDataArray, OrderModel, OrderQueryParams } from '@app/interfaces/order';
import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

const url = `/api/orders`;

export const getOrdersApi = async (params: OrderQueryParams): Promise<OrderDataArray | undefined> => {
  try {
    const response = await axiosApi.get<OrderDataArray>(url, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getOrderApi = async (orderId: number): Promise<OrderModel | undefined> => {
  try {
    const response = await axiosApi.get(`${url}/${orderId}`);
    const {data} = response.data;
    return data.attributes;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createOrderApi = async (orderData: OrderModel) => {
  try {
    const response = await axiosApi.post(url, orderData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateOrderApi = async (orderId: number, formData: OrderModel) => {
  try {
    const response = await axiosApi.put(`${url}/${orderId}`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteOrderApi = async (orderId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${orderId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const uploadImageOrderApi = async (orderId: number, formData: any) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
    }});
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const removeImageOrderApi = async (orderId: number, imageId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/remove`, { image_id: imageId });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportOrderApi = async (params?: Record<string, unknown>) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `orders.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const fetchCanceledOrders = async (): Promise<any | undefined> => {
  try {
    const response = await axiosApi.get<OrderDataArray>(url);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const fetchReturnedOrders = async (): Promise<any | undefined> => {
  try {
    const response = await axiosApi.get<OrderDataArray>(url);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getActivitiesApi = async (params: string) => {
  try {
    const response = await axiosApi.get(`${url}/activities`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateStatusApi = async (orderId: number, formData: any) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/update_status`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error); // This throws an error
    throw error; // Ensure error propagates to Redux thunk
  }
};

export const updateRemarkApi = async (orderId: number, remark: string) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/update_remark`, { remark });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

export const getListEmployees = async (q?: string): Promise<any | undefined> => {
  try {
    const response = await axiosApi.get<any>(`${url}/list_employee`, { params: q });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const sendZaloMessageApi = async (orderId: number) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/send_zalo_message`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const transferCustomerApi = async (orderId: number, formData: any) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/transfer_customer`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const combineOrderApi = async (orderId: number, formData: any) => {
  try {
    const response = await axiosApi.post(`${url}/${orderId}/combine`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const printCombineOrderApi = async (orderId: Number) => {
  try {
    const response = await axiosApi.get(`${url}/${orderId}/print_combine`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
export const getOrderDashboardApi = async (params?: { from_date?: string; to_date?: string }) => {
  try {
    const response = await axiosApi.get(`${url}/dashboard`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export interface DeliveryBucket {
  order_count: number;
  total_amount: number;
}

export interface DeliverySummary {
  today: DeliveryBucket;
  tomorrow: DeliveryBucket;
  late: DeliveryBucket;
  as_of: string;
}

/** Số đơn theo mốc giao hàng — dùng cho dải cảnh báo trên màn Đơn hàng. */
export const getDeliverySummaryApi = async (): Promise<DeliverySummary | undefined> => {
  try {
    const response = await axiosApi.get<DeliverySummary>(`${url}/delivery_summary`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
